import React, { Component } from "react";
import { AppScreen } from "../AppScreen";
import { ScreenChangeEvent } from "./events/ScreenEvent";
import { App } from "../App";
import { LoadingScreen } from "./screens/LoadingScreen";
import { LandingScreen } from "./screens/LandingScreen";
import { MeetTheCharactersScreen } from "./screens/MeetTheCharactersScreen";
import { Menu } from "./components/Menu";
import { GamesActivitiesScreen } from "./screens/GamesActivitiesScreen";
import { ColourMeScreen } from "./screens/ColourMeScreen";
import { SearchFindScreen } from "./screens/SearchFindScreen";
import { QuizScreen } from "./screens/QuizScreen";
import { ParentZoneScreen } from "./screens/ParentZoneScreen";
import { IFrameScreen } from "./screens/IFrameScreen";
import { EscalatorSafetyScreen } from "./screens/EscalatorSafetyScreen";
import desktopMode from "../assets/images/desktopMode.svg";
import { MatchingPairsScreen } from "./screens/MatchingPairsScreen";


export interface MainProps
{
    onUIReadyCB: () => void;
}

interface MainState 
{
    screen: AppScreen;
}

export class MainUI extends Component<MainProps, MainState>
{
    constructor(props: MainProps)
    {
        super(props);

        this.state = {
            screen: AppScreen.Loading,
        };
    }

    public componentDidMount(): void
    {
        App.I.addEventListener(ScreenChangeEvent.SCREEN_CHANGED, this.onScreenChanged, this);

        this.props.onUIReadyCB();
    }

    private onScreenChanged({ screen }: ScreenChangeEvent): void
    {
        this.setState({
            screen: screen,
        });
    }

    public render(): JSX.Element
    {
        return (
            <>
                {App.I.isDesktopMode
                    ?
                    <>

                    </>
                    :
                    <main>
                        {this.state.screen === AppScreen.Landing
                            ?
                            <Menu />
                            : null
                        }
                        {
                            (() =>
                            {
                                switch (this.state.screen)
                                {
                                    case AppScreen.Loading:
                                        return (
                                            <LoadingScreen />
                                        );

                                    case AppScreen.ParentZone:
                                        return (
                                            <ParentZoneScreen />
                                        );

                                    case AppScreen.Landing:
                                        return (
                                            <LandingScreen />
                                        );

                                    case AppScreen.ParentZoneIframe:
                                        return (
                                            <IFrameScreen />
                                        );

                                    case AppScreen.EscalatorSafety:
                                        return (
                                            <EscalatorSafetyScreen />
                                        );

                                    case AppScreen.GamesActivities:
                                        return (
                                            <GamesActivitiesScreen />
                                        );

                                    case AppScreen.MeetTheCharacters:
                                        return (
                                            <MeetTheCharactersScreen />
                                        );

                                    case AppScreen.SearchAndFind:
                                        return (
                                            <SearchFindScreen />
                                        );

                                    case AppScreen.ColourMe:
                                        return (
                                            <ColourMeScreen />
                                        );

                                    case AppScreen.Quiz:
                                        return (
                                            <QuizScreen />
                                        );

                                    case AppScreen.MatchingPairs:
                                        return (
                                            <MatchingPairsScreen />
                                        );
                                }
                            })()
                        }
                    </main>

                }
            </>
        );
    }

    public componentWillUnmount(): void
    {
        App.I.removeEventListener(ScreenChangeEvent.SCREEN_CHANGED, this.onScreenChanged);
    }
}